import React, { CSSProperties } from "react";
import styled from "styled-components";
import { ReactComponent as LogoTextSVG } from "../assets/logo_text.svg";

const LoadingTakenWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #1e223a;
  border-radius: 6px;

  &.loading-icon__only_img {
    border-radius: 50% !important;
  }

  .loading-icon {
    &.loading-icon-border {
      border-radius: 50%;
      border: 2px solid white;
    }

    svg {
      color: #2effbd;
      font-size: 3rem;
      /* animation: heartbeat 1.5s ease-in-out infinite both; */
    }

    @keyframes heartbeat {
      from {
        transform: scale(1);
        transform-origin: center center;
        animation-timing-function: ease-out;
      }
      10% {
        transform: scale(0.91);
        animation-timing-function: ease-in;
      }
      17% {
        transform: scale(0.98);
        animation-timing-function: ease-out;
      }
      33% {
        transform: scale(0.87);
        animation-timing-function: ease-in;
      }
      45% {
        transform: scale(1);
        animation-timing-function: ease-out;
      }
    }
  }

  .loading-text {
    padding-left: 0.5rem;
    font-weight: 900;
    color: grey;
    font-size: minmax(2rem, 3vw);
  }

  & > span svg {
    max-width: 200px;
    fill: white;
  }
`;

const LoadingTaken = (props) => {
  const { isLoading, style = {}, content = "Loading...", img } = props;
  return (
    <LoadingTakenWrapper
      style={{ ...style }}
      className={`${content.length === 0 ? "loading-icon__only_img" : ""}`}
    >
      <span className={`loading-icon ${img ? "loading-icon-border" : ""} `}>
        {img ? img : <LogoTextSVG />}
      </span>
      {content.length > 0 && (
        <span
          className={"loading-text"}
          style={{
            marginTop: `${img ? "1rem" : "3rem"}`,
          }}
        >
          {content}
        </span>
      )}
    </LoadingTakenWrapper>
  );
};

export default LoadingTaken;
